import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace WhatsAppMessageValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
